<template>
  <dashboard-layout :fluid="true">
    <section class="background-light">
      <div class="container container--vertical">
        <h1>Studies</h1>
        <current-study class="my-10" />
      </div>
    </section>
    <art-club-explained class="explanation" />
    <section class="border-top background-grey studies">
      <div class="container container--vertical">
        <h1>All studies</h1>
        <study-list />
      </div>
    </section>
  </dashboard-layout>
</template>

<script>
import StudyList from '@/components/art-club/StudyList';
import CurrentStudy from '@/components/art-club/CurrentStudy';
import ArtClubExplained from '@/components/art-club/ArtClubExplained';

export default {
  name: 'art-club',
  components: {
    StudyList,
    CurrentStudy,
    ArtClubExplained,
  },
};
</script>

<style lang="scss" scoped>
.background-grey {
  background: color('background', 'base');
}

.background-light {
  background: color('background', 'light');
}

.border-top {
  border-top: 1px solid color('grey', 'light');
  border-block: 1px solid color('grey', 'light');
}

.explanation {
  margin-bottom: 2rem;
  @media screen and (min-width: 1024px) {
    margin-bottom: 0rem;
    transform: translateY(50%);
  }
}

.studies {
  padding-top: 2rem;
  padding-bottom: 2rem;

  @media screen and (min-width: 1024px) {
    padding-top: 120px;
    padding-bottom: 120px;
  }
}

.current-study {
  padding: 64px 0;
}
</style>
